import React from 'react';
import { GroupSidebar, IconAgency } from '@esg/ui';
import { billSidebarConstants } from '../../Constants';


export const BillSidebar: React.FC = () => {

    return (
        <GroupSidebar
            label='Bill & Payment'
            sidebarItems={billSidebarConstants}
            Icon={<IconAgency.Menu.BillAndPay />}
            border={true}
        />
    );
};
